import { supabase } from "./supabase";
import { getDeviceId, getGuestIdentity } from "./guestIdentityService";

type RpcResult = { data: any[]; error: any };

const inflight = new Map<string, Promise<RpcResult>>();
const lastResult = new Map<string, { ts: number; result: RpcResult }>();

const FRESH_WINDOW_MS = 500;

export function fetchPollResponses(pollId: string): Promise<RpcResult> {
  const cached = lastResult.get(pollId);
  if (cached && Date.now() - cached.ts < FRESH_WINDOW_MS) {
    return Promise.resolve(cached.result);
  }

  const existing = inflight.get(pollId);
  if (existing) return existing;

  const promise = (async () => {
    try {
      // Fingerprint stable OBLIGATOIRE (même calcul que get_my_poll_response) :
      // sur un sondage `voters`, un votant invité sans fingerprint reçoit
      // 0 ligne — cf. bug « 0 votant » (PR #1027).
      const identity = await getGuestIdentity();
      const result = (await supabase.rpc("get_poll_responses", {
        p_poll_id: pollId,
        p_device_id: getDeviceId(),
        p_fingerprint: identity.stableFingerprint || null,
      })) as RpcResult;
      lastResult.set(pollId, { ts: Date.now(), result });
      return result;
    } finally {
      inflight.delete(pollId);
    }
  })();

  inflight.set(pollId, promise);
  return promise;
}

export function invalidatePollResponses(pollId?: string) {
  if (pollId) {
    lastResult.delete(pollId);
    inflight.delete(pollId);
  } else {
    lastResult.clear();
    inflight.clear();
  }
}
